module.exports = __webpack_public_path__ + "static/media/vtex34.451f4838.png";